import { render, staticRenderFns } from "./DinvoiceCreate.vue?vue&type=template&id=2ec37149&scoped=true"
import script from "./DinvoiceCreate.vue?vue&type=script&lang=js"
export * from "./DinvoiceCreate.vue?vue&type=script&lang=js"
import style0 from "./DinvoiceCreate.vue?vue&type=style&index=0&id=2ec37149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec37149",
  null
  
)

export default component.exports